//Preloader for Blog
var preloader = document.getElementById("preloader");

if (preloader) {
  setTimeout(function () {
    preloader.style.display = "none";
  }, 2000);
}
import Swiper from "swiper/bundle";
import '@justinribeiro/lite-youtube';

(function ($) {
  "use strict";

  // Bypass prod authorization with ajax calls, this is temporal only while we are testing
  // TODO: this must be removed before going to production.
  var username = "fmp_user";
  var password = "4xkVN7NKQCO4wvr5EH0MFxKH2";
  var basicAuth = 'Basic ' + btoa(username + ':' + password);
  $.ajaxSetup({
    headers: { Authorization: basicAuth },
  });


  $(document).ready(function ($) {
    /* DISCLOSURE and Progress bar BAR */
    if ($(".disclosure-bar")[0]) {
      $(function () {
        var shrinkHeader = 200;
        $(window).scroll(function () {
          // calculate the percentage the user has scrolled down the page
          var scrollPercent =
            (100 * $(window).scrollTop()) /
            ($(document).height() -
              $(".fmp-recommended-posts").height() -
              $("footer").height() -
              $(".post-header").height() -
              $(".header-logos").height() -
              517 -
              360);
          var scroll = getCurrentScroll();

          if ($(window).width() < 768) {
            var scrollPercent =
              (100 * $(window).scrollTop()) / $(".blog-wrap").height();
            scroll = getCurrentScroll();

            if (scroll >= 920) {
              $(".bar-long").css({
                width: scrollPercent - 5 + "%",
                top: "0px",
              });
            } else {
              $(".bar-long").css({ width: 0, top: 0 });
            }
          } else {
            var scrollPercent =
              (100 * $(window).scrollTop()) / $(".blog-wrap").height();

            setTimeout(() => {
              scroll = getCurrentScroll();

              if (scroll >= 1) {
                $(".bar-long").css({ width: scrollPercent - 3 + "%", top: 0 });
              } else {
                $(".bar-long").css({ width: 0, top: 0 });
              }
            }, 100);
          }

          let contentPosition = $(".blog-wrap").offset().left + 69 + 1027 + 30;
          const bodyHeight = document.body.scrollHeight;

          let customScrollPercent = 20;

          if (bodyHeight < 5000) {
            customScrollPercent = 50;
          } else if (bodyHeight < 6000) {
            customScrollPercent = 40;
          } else if (bodyHeight < 7000) {
            customScrollPercent = 30;
          }

          if (bodyHeight > 4000) {
            if (scrollPercent > customScrollPercent && scrollPercent < 100) {
              $(".back-to-top").css({
                opacity: 1,
                left: contentPosition + "px",
                position: "fixed",
              });
            } else if (scrollPercent >= 96) {
              $(".fmp-article-wrap").css({ position: "relative" });
              $(".back-to-top").css({
                position: "absolute",
                bottom: "19px",
                left: contentPosition + "px",
              });
            } else {
              $(".back-to-top").css({ opacity: 0 });
            }
          }
        });
        function getCurrentScroll() {
          return window.pageYOffset || document.documentElement.scrollTop;
        }
      });
    }
    /* END DISCLOSURE BAR*/

  });

  // Search
  $(".fmp-search-header").click(function () {
    if ($("#search-box-footer").hasClass("visible")) {
      $("#search-box-footer").toggleClass("visible");
    }
    $("#search-box").toggleClass("visible");

    if ($(".career-advice-menu").hasClass("active")) {
      $(this).parents(".career-advice-menu").toggleClass("active");
    }

    setTimeout(() => {
      $("#search-article").focus();
    }, 200);
  });
  
  $("#fmp-search-footer").click(function () {
    if ($("#search-box").hasClass("visible")) {
      $("#search-box").toggleClass("visible");
    }
    $("#search-box-footer").toggleClass("visible");
    if ($(".career-advice-menu").hasClass("active")) {
      $(this).parents(".career-advice-menu").toggleClass("active");
    }

    setTimeout(() => {
      $("#search-article-footer").focus();
    }, 200);
  });

  var blogNav = document.querySelector(".menu-inner-blog-menu-container"),
    blogMenuToggle = document.querySelector(".blog-menu-toggle");
  if (blogMenuToggle) {
    blogMenuToggle.addEventListener("click", function () {
      blogNav.classList.toggle("expanded");
      blogMenuToggle.classList.toggle("expanded");
      setAriaExpanded(button);
      setAriaExpanded(menu);
    });
  }

  $(".mobile-menu").on("click", function () {
    if ($(".search-box").hasClass("visible")) {
      $(".search-box").toggleClass("visible");
    }

    $(this).parents(".career-advice-menu").toggleClass("active");
  });

  /* Read more Reviews */
  (function (window, $, undefined) {

    var RESET_CLASS = "reset-style";

    function splitLines(container, opentag, closingtag) {
      var spans = container.children,
        top = 0,
        tmp = "";

      container.innerHTML = container.textContent.replace(/\S+/g, "<n>$&</n>");
      for (let i = 0; i < spans.length; i++) {
        var rect = spans[i].getBoundingClientRect().top;

        if (top < rect) tmp += closingtag + opentag;
        top = rect;
        tmp += spans[i].textContent + " ";
      }
      container.innerHTML = tmp += closingtag;
    }

    function splitWords(container, opentag, closingtag) {
      var spans = container.children,
        left = 0,
        tmp = "";

      container.innerHTML = container.textContent.replace(/\S+/g, "<n>$&</n>");
      for (let i = 0; i < spans.length; i++) {
        var rect = spans[i].getBoundingClientRect().left;
        if (left < rect) tmp += closingtag + opentag;
        left = rect;
        tmp += spans[i].textContent + " ";
      }
      container.innerHTML = tmp += closingtag;
    }

    $.fn.multiTextToggleCollapse = function (methodOrOptions) {

      this.each(function () {
        var methods = {
          init: function (options) {
            const author = $(this)
              .parents(".review")
              .find(".review__meta")
              .text();

            var $this = $(this);
            var $wrapBox = $this;
            var text = $wrapBox.text();
            var fullText = text;

            splitLines($wrapBox.get(0), "<span>", "</span>");
            var $lines = $wrapBox.children("span").filter((i) => i < 4);
            var $lastLine = $lines.last();

            splitWords($lastLine.get(0), "<span>", "</span>");

            var addReadMore = false;
            if (
              $this.parents(".site-main").hasClass("non-tsap") &&
              fullText.length > 185
            ) {
              addReadMore = true;
            } else if (fullText.length > 210) {
              addReadMore = true;
            }

            if (addReadMore) {
              var leftLeft = $lastLine.children("span").filter((i, el) => {
                return (
                  el.getBoundingClientRect().right <
                  $wrapBox.get(0).getBoundingClientRect().right - 110
                );
              });
              $lastLine.html(leftLeft);
              $lastLine
                .find("span")
                .last()
                .html($lastLine.find("span").last().text().replace(/ /g, ""));
              $lastLine.append("... ");
            } else {
              $lastLine.append("");
            }
            $wrapBox.html($lines);
            const finalText = $wrapBox.text();
            $wrapBox.html($("<div></div>").html(finalText));
            if (addReadMore) {
              $wrapBox
                .find(">:first-child")
                .append(
                  $(
                    '<span class="read-more__link read-more__expand">Read More</span>'
                  )
                );
            }

            $wrapBox.on("click", ".read-more__expand", function (event) {
              event.stopPropagation();
              $wrapBox.find(">:first-child").html(fullText);
              $wrapBox
                .find(">:first-child")
                .append(
                  $(
                    '<span class="read-more__link read-more__collapse">See Less</span>'
                  )
                );
            });

            $wrapBox.on("click", ".read-more__collapse", function (event) {
              event.stopPropagation();
              $wrapBox.find(">:first-child").html(finalText);
              $wrapBox
                .find(">:first-child")
                .append(
                  $(
                    '<span class="read-more__link read-more__expand">Read More</span>'
                  )
                );
            });

            if (addReadMore) {
              $("body").click(function () {
                $wrapBox.find(">:first-child").html(finalText);
                $wrapBox
                  .find(">:first-child")
                  .append(
                    $(
                      '<span class="read-more__link read-more__expand">Read More</span>'
                    )
                  );
              });
            }

            var lineHeightStr = $wrapBox.css("line-height"); // normal 12px 1.2 120% 1.2em
            var fontSize = parseInt($wrapBox.css("font-size")); // 12px -> 12
            var strategyMode = {
              normal: function () {
                return fontSize;
              },
              px: function (num) {
                return +num;
              },
              em: function (num) {
                return num * fontSize;
              },
              "%": function (num) {
                return (num / 100) * fontSize;
              },
              void: function (num) {
                return num * fontSize;
              },
            };

            var num = (lineHeightStr.match(/\d+(.\d+)?/) || [1])[0]; // 12px -> 12
            var unit = lineHeightStr.replace(num, "") || "void"; // 12px -> px

            var lineHeight = strategyMode[unit](num).toFixed(2);

          },
          hide: function () {
            $(this).find("a.read-more__collapse").click();
          },
        };

        if (methods[methodOrOptions]) {
          return methods[methodOrOptions].apply(
            this,
            Array.prototype.slice.call(arguments, 1)
          );
        } else if (typeof methodOrOptions === "object" || !methodOrOptions) {
          // Default to "init"
          return methods.init.apply(this, arguments);
        } else {
          $.error(
            "Method " + methodOrOptions + " does not exist on jQuery.tooltip"
          );
        }
      });
    };
  })(this, jQuery);

  /* REVIEW SLIDER */
  if($(".review-slider")){
    const swiperReview = new Swiper(".review-slider", {
      on: {
        slideChange: function () {
          $(".review-text").multiTextToggleCollapse("hide");
        },
      },
      loop: true,
      spaceBetween: 20,
      slidesPerView: 1,
      breakpoints: {
        768: {
          slidesPerView: 2,
          slidesPerGroup: 2,
        },
      },

      // Navigation arrows
      navigation: {
        nextEl: ".review-slider-button-next",
        prevEl: ".review-slider-button-prev",
      },
    });
  }
  /* END REVIEW SLIDER */

  $(function () {
    if ($(".page-template-resume").length) {
      window.addEventListener("DOMContentLoaded", (event) => {
        $(".review-text").multiTextToggleCollapse({
          line: 4,
        });
      });
    } else {
      $(".review-text").multiTextToggleCollapse({
        line: 4,
      });
    }
  });

  // Add smooth scrolling to Top Services links
  if ($("top_service_link")) {
    $(".top_service_link").on("click", function (event) {
      if (this.hash !== "") {
        event.preventDefault();
        var hash = this.hash;
        $("html, body").animate(
          {
            scrollTop: $(hash).offset().top - 40,
          },
          800,
          function () {
          }
        );
      }
    });
  }

  // Terms Page
  if($("#terms-of-use")){
    $("#terms-of-use").on("click", function () {
      $(this).addClass("active");
      $("#terms-of-use__section").addClass("active");
      $("#privacy-policy,#privacy-policy__section").removeClass("active");
    });
  }

  if($("#privacy-policy")){
    $("#privacy-policy").on("click", function () {
      $(this).addClass("active");
      $("#privacy-policy__section").addClass("active");
      $("#terms-of-use,#terms-of-use__section").removeClass("active");
    });
  }

  if($('.fmp-sample')){
    $(".inner-wrap").on("click", function(){
      var sampleID = $(this).attr('data-id');
      $(".fmp-sample-view").show();
      $(".sample-img").removeClass("active");
      $("#" + sampleID).addClass("active");
    });
    $(".fmp-sample-view").on("click", ".close", function(){
      $(".fmp-sample-view").hide();
    });
    
    $(document).mouseup(function (e) {
      var container = $(".sample-img");
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        $(".fmp-sample-view").hide();
      }
    });
  }

})(jQuery);
